export enum EventDisplayType {
  learner,
  employer,
}
